import { assign } from 'lodash';
import EventEmitter from '@wsb/commerce-event-emitter';
import { AppDispatcher } from '@wsb/guac-widget-shared/lib/common/ols-core/shared-bundle';
import ProspectiveCustomerConstants from './ProspectiveCustomerConstants';

class ProspectiveCustomerStore extends EventEmitter {
  constructor() {
    super(...arguments);

    this.state = {
      fetching: false,
      fetched: false,
      email: null,
      genericError: false,
      invalidEmailError: false
    };
    this.register();
  }

  setState(newState) {
    assign(this.state, newState);
    this.emit('change');
  }

  getState() {
    return this.state;
  }

  register() {
    this.dispatchToken = AppDispatcher.register((payload) => {
      const { action } = payload;
      const { data } = action;

      switch (action.type) {
        case ProspectiveCustomerConstants.SET_EMAIL:
          this.setState({
            fetching: false,
            fetched: false,
            email: data,
            genericError: false,
            invalidEmailError: false
          });
          break;
        case ProspectiveCustomerConstants.SEND_EMAIL:
          this.setState({
            fetching: true,
            fetched: false,
            genericError: false,
            invalidEmailError: false
          });
          break;
        case ProspectiveCustomerConstants.EMAIL_SENT:
          this.setState({
            fetching: false,
            fetched: true,
            genericError: false,
            invalidEmailError: false
          });
          break;
        case ProspectiveCustomerConstants.INVALID_EMAIL:
          this.setState({
            fetching: false,
            fetched: false,
            genericError: false,
            invalidEmailError: true
          });
          break;
        case ProspectiveCustomerConstants.EMAIL_SENT_ERROR:
          this.setState({
            fetching: false,
            fetched: false,
            genericError: true,
            invalidEmailError: false
          });
          break;
        default:
          break;
      }
    });
  }
}

export default new ProspectiveCustomerStore();
